import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { Logger } from './services/Logger';
import { evictAllExpired } from './services/CacheService';
import 'maplibre-gl/dist/maplibre-gl.css';
import './styles/global.css';

// Install unhandled error / rejection handlers before the React tree mounts.
Logger.setLevel('info');
Logger.setContext({ app: 'efb-web', build: (import.meta as unknown as { env?: { MODE?: string } }).env?.MODE ?? 'unknown' });
Logger.installGlobalHandlers();

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Keep the persistent offline cache lean without blocking the first render.
if (typeof indexedDB !== 'undefined') {
  void evictAllExpired()
    .then((deleted) => Logger.debug('Expired offline cache entries removed', deleted))
    .catch((error) => Logger.warn('Offline cache cleanup failed', { error: String(error) }));
}

// The service worker is generated by vite-plugin-pwa (VitePWA). In dev we
// don't register it; the plugin does auto-registration in production builds
// via the virtual `virtual:pwa-register` module. We keep a small fallback
// here so existing /sw.js deployments continue to work.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      Logger.warn('Service worker registration failed');
    });
  });
}
